setTimeout(function () {
    //disable cart ajax functions

    $(function () {
        $(".js-qty").find("input").removeClass("js-qty__input");
        $(".js-qty").find("input").css("text-align", "center");
        $(".js-qty__adjust").remove();
        $(".update-cart").show();

        $(".options-additional-item").css("margin-right", "20px");
    });
}, 5);
